/* What is left of the cascade after #1466 handed the record page's sections,
   headings, counts and anchors to `@solum/ui`'s Connections: the strip carrying
   Personalize, and the CRM record page's own tabbed section
   (`RegisteredRelationSection`), which still draws its own header because a
   section chosen by a tab has to name itself.

   `.none`, `.cmd`, `.barLabel` and `.groupBar` went with the code that used
   them. A class nobody imports is a rule nobody can find the effect of. */
.cascade { display: flex; flex-direction: column; gap: var(--sp-3); }
.surfaceActions { display: flex; align-items: center; flex-wrap: wrap; gap: var(--sp-2); }
/* The filter in force, over a plate's grid: the one state a column menu cannot
   show from a closed menu, so a filtered grid never looks unfiltered. */
.filterSummary { display: flex; flex-wrap: wrap; gap: var(--sp-1); padding: var(--sp-2) var(--sp-3) 0; }

.section { border-top: 1px solid var(--hair, var(--border)); padding-top: var(--sp-2); }
.section:first-child { border-top: 0; padding-top: 0; }

.head { margin: 0; display: flex; align-items: center; gap: var(--sp-2); }
/* the add control only appears on hover or focus-within — every section
   carrying a permanent button would read as nine competing calls to action */
.add { flex: none; opacity: 0; transition: opacity var(--dur-1) var(--ease); }
.section:hover .add, .section:focus-within .add { opacity: 1; }
.toggle {
  display: flex; align-items: center; gap: var(--sp-2); width: 100%;
  background: none; border: 0; padding: var(--sp-1-5) var(--sp-0-5); font: inherit; cursor: pointer;
  color: var(--ink); text-align: left;
}
.toggle:hover .label { color: var(--brand-text); }
.toggle:focus-visible { outline: 2px solid var(--focus-ring); outline-offset: 1px; border-radius: var(--r-sm); }

.twist {
  flex: none; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;
  border: 1px solid var(--hair); border-radius: var(--r-sm);
  color: var(--muted); font-size: 11px; font-weight: 700; line-height: 1;
}
.section[data-open] .twist { background: var(--brand); border-color: var(--brand); color: var(--brand-contrast); }

.label { font-size: var(--fs-sm); font-weight: 650; letter-spacing: -0.01em; }
.staticTitle { font-size: var(--fs-sm); font-weight: 700; letter-spacing: -0.01em; padding: var(--sp-1-5) var(--sp-0-5); }
.description { font-size: var(--fs-xs); font-weight: 400; color: var(--muted); }
.n {
  flex: none; font-size: 0.625rem; font-weight: 800; font-variant-numeric: tabular-nums;
  background: color-mix(in srgb, var(--brand) 16%, transparent); color: var(--brand-text);
  border-radius: 999px; padding: 1px 6px;
}

/* The two switchers, side by side and in BOTH modes — the way back is always
   where the way out was (#2324). */
/* WRAPS, and never wider than the row it sits in. At 390px the strip — List |
   Graph, reset, Network | Metro, full screen — is wider than the column, and as
   an unwrapping inline-flex it ran past the edge with "Metro | Ne" left on
   screen and the rest of the switcher, and Full screen, cut off. */
.workspaceModes {
  display: inline-flex; align-items: center; gap: var(--sp-2);
  flex-wrap: wrap; max-width: 100%; min-width: 0;
}

/* ── THE FULL-SCREEN GRAPH (#2349 §E, mock item 33) ─────────────────────────
 * The shared `Modal`'s panel, given the window rather than a dialog's usual
 * column: a relationship network is exactly the surface that a 560px centred
 * card cannot show, which is why Expand exists at all. `min-height` rather than
 * a fixed one so the panel still fits a short viewport and scrolls inside
 * itself, which is what the Modal already does with a tall child.
 */
.graphFullPanel {
  width: min(96vw, 1600px); max-width: 96vw;
  min-height: min(92vh, 900px); max-height: 92vh;
  display: flex; flex-direction: column; overflow: auto;
}
